import React, { useEffect, useState, useMemo } from 'react';
import './report.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useCSVDownloader } from 'react-papaparse';
import { useNavigate } from 'react-router-dom';
import { exportToCSV, exportToExcel, exportToPDF } from '../../utils/Exports';
import { FormGroup, Button, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import $ from 'jquery';
import moment from 'moment';
import formatHeaderName from '../../utils/formatHeaderName';
import { parseValue } from '../../utils/Common';
import Table from '../common/Table';


const common = require('../../utils/Common');

export default function ReceiptReports() {
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const { CSVDownloader } = useCSVDownloader();
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateData, setUpdateData] = useState({
    deposit_as_per_portal: ''
  });
  const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
  
  const navigate = useNavigate();

  useEffect(() => {
    checkAccess();
  }, []);

  const checkAccess = async () => {
    let rights = await common.checkAccessRights(window.location.pathname);
    if (!rights.view) {
      alert("Access Denied");
      navigate("/");
      return;
    } else {
      setUserRights(rights);
      getReportData();
    }
  }
  const getReportData = async (limit = 10, offset = 0, search = {}, isExport = 0) => {
    var parameters = {
      'source': 'Admin',
      'report_name': 'receipt_reports',
      'start_date': $('#Date-from').val(),
      'end_date': $('#Date-to').val(),
    };
    if (!isExport) {
      parameters.limit = limit;
      parameters.offset = offset;
    }
    let response = await common.apiRequest('post', '/reports/get-reports', parameters);
    let data = (response.data && response.data.data) ? response.data.data : [];
    if (isExport) {
      return data.reportData;
    }
    const keysToExclude = ['order_item_id', 'logistics_order_id'];
    const cols = common.getReportColumns(keysToExclude, data.keys, ChangeIntDecimals);
    setColumnDefs(cols);

    // Set row data
    setRowData(data.reportData);
    setTotalRecords(data.totalRecords);
  }

  const ChangeIntDecimals = [
    'tax_invoice_value','deposits','bank_charges','deposit_as_per_portal'
  ];

  const excludeFields = ['order_item_id'];

  const data = rowData.map((row, index) => {
    const newRow = {
        slNo: index + 1 
    };
      Object.keys(row)
          .filter(key => !excludeFields.includes(key))
          .forEach(key => {
              newRow[formatHeaderName(key)] = row[key];
          });
      return newRow;
  });
  const handleExportCSV = async () => {
    let data = await getReportData(0, 0, {}, 1);
    exportToCSV(data, 'Receipt report');
  }

  const handleExportExcel = async () => {
    let data = await getReportData(0, 0, {}, 1);
    exportToExcel(data, 'Receipt report');
  }

  const handleExportPDF = async () => {
    let data = await getReportData(0, 0, {}, 1);
    exportToPDF(data, 'Receipt report');
  }
  const onSelectionChanged = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data);
    setSelectedRows(selectedData);
  };

  const handleUpdate = async () => {
    if (selectedRows.length !== 1) {
      alert("Please select exactly one row to update");
      return;
    }

    try {
      const parameters = {
        report_name: 'receipt_reports',
        order_item_id: selectedRows[0].order_item_id,
        update_data: {
          deposit_as_per_portal: updateData.deposit_as_per_portal,
        }
      };
      const response = await common.apiRequest('post', '/reports/update-report', parameters);

      if (response.data && response.data.code === 'success') {
        alert('Record updated successfully');
        setIsModalOpen(false);
        getReportData();
      } else {
        alert('Failed to update record');
      }
    } catch (error) {
      console.error('Error updating record:', error);
      alert('Error updating record');
    }
  };
  return (
    <>
      <div className="row report-margin">
        <div className='col-md-10'>
          <h3>Receipt Reports</h3>
        </div>
        <Form className='row'>
          <FormGroup className='col-md-4 row'>
            <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
            <input type='date' defaultValue={moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getReportData()} className="form-control col-md-5" id="Date-from" name="Date-from"></input>
          </FormGroup>
          <FormGroup className='col-md-4 row'>
            <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
            <input type='date' defaultValue={moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getReportData()} className="form-control col-md-5" id="Date-to" name="Date-to"></input>
          </FormGroup>
        </Form>
        <div className="col-md-12 button-container">
          <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
          <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
          <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
          {selectedRows.length === 1 && (
            <button
              className='btn button-product'
              onClick={() => setIsModalOpen(true)}
            >
              Update Selected
            </button>
          )}
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
            <Table 
              columns={columnDefs}
              data={rowData}
              totalRecords={totalRecords}
              pageSize={10}
              onPageChange = {getReportData}
            />
          </div>
        </div>
      </div>

      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)}>
        <ModalHeader toggle={() => setIsModalOpen(false)}>Update Record</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="deposit">Deposit as per Portal</Label>
            <Input
              type="number"
              id="deposit"
              value={updateData.deposit_as_per_portal}
              onChange={(e) => setUpdateData({ ...updateData, deposit_as_per_portal: e.target.value })}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpdate}>Update</Button>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  )
}